import get from './get'
import update from './update'
import getOne from './get-one'
import create from './create'
import getTaskRecommendations from './get-task-recommendations'
import getCreatives from './get-creatives'
import getResearch from './get-research'

const services = {
  get,
  update,
  getOne,
  create,
  getTaskRecommendations,
  getCreatives,
  getResearch,
}

export default services
